import {
  Box,
  Button,
  Divider,
  MediaBox,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { BlockTitle } from "areas/instant-gift/item/components"
import { jewlr_t } from "helpers/application"

import Demo from "./demo"
import HowItWorks from "./how-it-works"
import MainBanner from "./main-banner"

const Heading = styled(Typography).attrs((props) => ({
  as: "h3",
  fontSize: "18px",
  fontWeight: "700",
  lineHeight: "20px",
  ...props,
}))``

const CTA = styled(Button).attrs({
  borderRadius: "5px",
  fontSize: "18px",
  height: "48px",
  letterSpacing: "0.5px",
  lineHeight: "16px",
  variant: "primary",
  width: { _: "100%", tablet: "auto" },
})``

const InstantGiftExplained = ({ action, inCart, inModal }) => {
  return (
    <div>
      {inModal ? (
        <Typography
          className="nowrap"
          fontSize="18px"
          lineHeight="20px"
          mb="10px"
          pb={2}
          textAlign="center"
        >
          Order Today, Share Right Away!
        </Typography>
      ) : (
        <Box mb={{ _: 3, tablet: 5 }}>
          <MainBanner />
        </Box>
      )}
      <Box
        {...(!inModal && { contain: true, mb: 4, px: 2 })}
        textAlign="center"
      >
        {!inModal && <BlockTitle center>How Instant Gift Works</BlockTitle>}
        <HowItWorks inCart={inCart} />
        <Divider color="grey.10" my={2} />
        <Heading mb={{ _: "10px", tablet: "12px" }} pt={{ tablet: "6px" }}>
          {inCart ? (
            `${jewlr_t("terms.Personalized")} Your Instant Gift Video`
          ) : (
            <>
              <MediaBox lessThan="tablet">
                Instant Gift Demo
                <br />
                What Your Loved One Receives
              </MediaBox>
              <MediaBox greaterThanOrEqual="tablet">
                Instant Gift Demo – What Your Loved One Receives
              </MediaBox>
            </>
          )}
        </Heading>
        <Typography
          fontSize="16px"
          mx="auto"
          width={{ _: "100%", tablet: "325px" }}
        >
          Your video includes a preview of your custom gift and a personal
          message.
        </Typography>
        {inCart && (
          <CTA mt={{ _: "10px", tablet: 3 }} onClick={() => action()}>
            Create Now!
          </CTA>
        )}
        <Box textAlign="left">
          <Demo inModal={inModal} />
        </Box>
        {inCart && (
          <CTA mt={{ _: "10px", tablet: 3 }} onClick={() => action()}>
            Create Now!
          </CTA>
        )}
      </Box>
    </div>
  )
}

InstantGiftExplained.propTypes = {
  action: PropTypes.func,
  inCart: PropTypes.bool,
  inModal: PropTypes.bool,
}

export default InstantGiftExplained
